import React, { useEffect, createRef } from "react";

import { Button } from '@mui/material';
import { useLocation, useNavigate } from "react-router-dom";
import BackIcon from '@mui/icons-material/ArrowBack';
import {CreateForms} from "../../../REST/utilities"
import {createFormBuilderLink} from "../../../helpers"
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import { useForm, Controller } from "react-hook-form";
//import 'react-cron-generator/dist/cron-builder.css'
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import FormHelperText from '@mui/material/FormHelperText';
import { CreateWorkorderBuilder, UpdateWorkorderBuilder, getWorkordersById } from '../../../REST/workorders'
import PageShell from '../../../themes/components/PageShell';
import PageHeader from '../../../themes/components/PageHeader';
import PageContent from '../../../themes/components/PageContent';
import Form from '../../../themes/components/Form';
import FormActions from '../../../themes/components/FormActions';
 




const CreateWorkorder = (props) => {
	const navigate = useNavigate()
	const location = useLocation()


	const isAddMode = location.pathname === "/settings/workorder/createWorkorder";
	const id = isAddMode ? null : location.pathname.replace("/settings/workorder/createWorkorder/", "")
	const gotoForm = (formId)=>{
		const url =createFormBuilderLink('build',formId)
		window.open(url, '_blank')
	}
	useEffect(() => {

		if (!isAddMode) 
		{
			getWorkordersById(id)
			.then((res) => {
				const data = res?.data
				const fields = [ 'name', 'adhoc', 'isPublic', 'description', 'formId', 'status'];
				fields.forEach((field) => {
					setValue(field, data[field])
					 
				}
				);
			})
				.catch((e) => { navigate("/settings/workorder") })
		}
		else
		{
			CreateForms()
			.then(({data})=>{
				setValue("formId",data._id )
			})
		}
	}, []);

	const modulevalues = ["Property", "Agreement"]
	 
	const schema = yup.object({	 
		name: yup.string().trim().required(),		 
		description: yup.string().trim().required(),
		adhoc: yup.boolean().required(),
		isPublic: yup.boolean().required(),
		formId:  yup.string().trim().required(),
		status: yup.boolean().required()
	}).required();


	const methods = useForm({
		defaultValues: {
		 	name: '',
			description: '',
			adhoc: true,
			isPublic: false,
			formId:null,
			status: true
		},
		resolver: yupResolver(schema)
	});
	const { control, register, getValues, setValue, clearErrors, reset, formState: { errors } } = methods;


	const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

	const saveForm = (data) => {
		 
		 
		if(isAddMode) {	

		  CreateWorkorderBuilder(data)
		  .then(()=>{
			  navigate("/settings/workorder"); 
		  })
		}
		else	
		{
			UpdateWorkorderBuilder(id,data)
			.then(()=>{
			  navigate("/settings/workorder"); 
			})
		}	
	}
	
	const FormBuilderControl = ({ errors, field }) => {
		const { name } = field
		return (
			<FormControl required error={isError(errors[name])} variant='standard' margin='dense' fullWidth>
				<input {...register(name)} type="hidden" />	
				<Button onClick={() => { gotoForm( field.value) }} variant="outlined" >Form Builder</Button>

				{errors[name] && <FormHelperText>{errors[name].fields.message}</FormHelperText>}
			</FormControl>
		)
	}
	 


	return (
		<PageShell>
			<PageHeader
				title={isAddMode ? 'Create Workorder' : 'Edit Workorder'}
				back
				onBack={() => navigate(-1)}
			/>
			<PageContent>
				<Form methods={methods} onSubmit={saveForm}>
					<Controller name="name" control={control}
						render={({ field }) =>
							<TextField margin='dense' error={isError(errors.name)} helperText={errors.name && errors.name.message}
								fullWidth label='Name' {...field} />} />
					<Controller name="description" control={control}
						render={({ field }) =>
							<TextField margin='dense' error={isError(errors.description)} helperText={errors.description && errors.description.message}
								fullWidth label='Description' {...field} />} />
					<Controller name="adhoc" control={control}
						render={({ field }) =>
						<FormControlLabel 
							control={<Checkbox checked={field.value} onChange={(e) => field.onChange(e.target.checked)} />} 
							label="Is Adhoc" />} />
				
				<Controller name="isPublic" control={control}
					render={({ field }) =>
						<FormControlLabel 
							control={<Checkbox checked={field.value} onChange={(e) => field.onChange(e.target.checked)} />} 
							label="Is Public" />} />
				
				<Controller name="status" control={control}
					render={({ field }) =>
						<FormControlLabel 
							control={<Checkbox checked={field.value} onChange={(e) => field.onChange(e.target.checked)} />} 
							label="Is Enabled?" />} />
				
				<Controller name="formId" control={control}
					render={({ field }) => <FormBuilderControl errors={errors} field={field} />} />
				
					<FormActions>
						<Button type="submit" variant="outlined" startIcon={<SaveOutlined />}>
							Save Workorder
						</Button>
					</FormActions>
				</Form>
			</PageContent>
		</PageShell>
	)


}
export default CreateWorkorder;



